module.exports = __webpack_public_path__ + "img/HotRate.c654dc50.gif";